import { typographyClassName } from '@creditornot/cb-ingredients';
import { InputSwitch } from '@creditornot/cb-switch';
import React, { useId } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

type InsightSettingsProps = {
  isVATEnabled: boolean;
  setIsVATEnabled: (isVATEnabled: boolean) => void;
};

const InsightSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  min-width: 250px;
`;

const SettingsRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const InsightSettings = ({ isVATEnabled, setIsVATEnabled }: InsightSettingsProps) => {
  const switchId = useId();
  return (
    <InsightSettingsContainer>
      <Typography.Heading6>
        <FormattedMessage id="insights.settings" />
      </Typography.Heading6>
      <SettingsRow>
        <label htmlFor={switchId} className={typographyClassName.Body3}>
          <FormattedMessage id="insights.enable-vat" />
        </label>
        <InputSwitch
          id={switchId}
          checked={isVATEnabled}
          onChange={({ currentTarget: { checked } }) => {
            setIsVATEnabled(checked);
          }}
        />
      </SettingsRow>
    </InsightSettingsContainer>
  );
};
